export const USER_TYPES = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    REGULAR_ACCOUNT: 'REGULAR_ACCOUNT'
}
export const PAGE_SIZE = 10;
